// src/core/storage.js
import Security from '@/core/security';

const defaultOpts = {encrypt: true};

const setItem = (key, value, opts = {}) => {
    try {
        const {encrypt} = Object.assign({}, defaultOpts, opts);

        if (value === null || typeof value === 'undefined') {
            localStorage.removeItem(key);
            return;
        }

        const raw = typeof value === 'string' ? value : JSON.stringify(value);

        if (encrypt) {
            const encrypted = Security.encryptContent(raw);
            localStorage.setItem(key, encrypted);
        } else {
            localStorage.setItem(key, raw);
        }
    } catch (e) {
        console.error('❌ storage.setItem error:', e, key, value);
    }
};

const getItem = (key, opts = {}) => {
    try {
        const {encrypt} = Object.assign({}, defaultOpts, opts);
        const stored = localStorage.getItem(key);

        if (!stored) return null;

        if (encrypt) {
            const decrypted = Security.decryptContent(stored);
            if (!decrypted) return null;
            try {
                return JSON.parse(decrypted);
            } catch {
                return decrypted; // si no es JSON, devuelvo string plano
            }
        }

        try {
            return JSON.parse(stored);
        } catch {
            return stored; // string plano
        }
    } catch (e) {
        console.error('❌ storage.getItem error:', e, key);
        return null;
    }
};

const removeItem = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (e) {
        console.error('❌ storage.removeItem error:', e);
    }
};

export {setItem, getItem, removeItem};